import { render, staticRenderFns } from "./ViewAttachedFile.vue?vue&type=template&id=e21dc3ec&scoped=true"
import script from "./ViewAttachedFile.vue?vue&type=script&lang=js"
export * from "./ViewAttachedFile.vue?vue&type=script&lang=js"
import style0 from "./ViewAttachedFile.vue?vue&type=style&index=0&id=e21dc3ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21dc3ec",
  null
  
)

export default component.exports